import React from "react";
import { styled } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { AvatarT } from "types/utils/avatar";
import { theme } from "styles/themes";
import { filterStyledProps } from "lib/helpers/filterStyledProps";

type LeaderboardAvatarPropsT = {
  avatar: AvatarT;
  fullName: string;
  size?: number;
  fontSize?: number;
  gradient?: boolean;
};
const LeaderboardAvatar = ({
  avatar,
  fullName,
  size = 28,
  fontSize = 12,
  gradient = false,
}: LeaderboardAvatarPropsT) => {
  const getInitials = (): string => {
    if (!fullName) return "";
    const names = fullName.trim().split(/\s+/);
    const first = names[0]?.[0] ?? "";
    const last = names.length > 1 ? names[names.length - 1][0] : "";
    return (first + last).toUpperCase();
  };

  if (avatar.thumb) return <Avatar sx={{ height: `${size}px`, width: `${size}px` }} src={avatar.thumb} />;

  return (
    <DefaultAvatar size={size} gradient={gradient} fontSize={fontSize}>
      {getInitials()}
    </DefaultAvatar>
  );
};

export const DefaultAvatar = styled("div", { shouldForwardProp: filterStyledProps(["size", "gradient", "fontSize"]) })<{
  size: number;
  fontSize: number;
  gradient: boolean;
}>(({ size, gradient, fontSize }) => ({
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: "50%",
  background: gradient
    ? `linear-gradient(135deg, ${theme.colors["picton-blue"]}, ${theme.colors["blue-ribbon"]})`
    : theme.colors["botticelli-blue"],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: gradient ? theme.colors.white : theme.colors["darker-blue"],
  fontSize: `${fontSize}px`,
  fontWeight: 600,
}));

export default LeaderboardAvatar;
